var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOnedrive = function SvgOnedrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#onedrive_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0364B8",
    d: "m22.496 16.1 7.686-7.351C28.586 2.523 22.245-1.23 16.02.368a11.64 11.64 0 0 0-6.83 4.874c.12-.003 13.307 10.857 13.307 10.857"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0078D4",
    d: "M14.199 6.626a9.27 9.27 0 0 0-4.89-1.387l-.12.003a9.305 9.305 0 0 0-7.517 14.626l11.515-1.442 8.829-7.118z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1490DF",
    d: "M30.182 8.749a7.534 7.534 0 0 0-3.508.6v-.001l-4.658 1.96 5.135 6.343 9.18 2.231A7.563 7.563 0 0 0 30.181 8.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28A8EA",
    d: "M1.672 19.869a9.3 9.3 0 0 0 7.637 3.987h20.363a7.56 7.56 0 0 0 6.658-3.974l-14.314-8.574z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "onedrive_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h37.236v24H0z"
  })))));
};
export default SvgOnedrive;